export const cssVariables: Record<string, string> = {};
